/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    // "aws_cognito_identity_pool_id": "us-west-2:32ab8955-d704-47aa-bf5d-b151ad0ce727",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_LQnstneoZ",
    "aws_user_pools_web_client_id": "41c5cdunc9bajbdmi7kaughurb",
    "auth": {
        "mandatorySignIn": true,
    },
    "oauth": {
        "domain": 'fhcrc-prd.auth.us-west-2.amazoncognito.com',
        "scope": ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        "redirectSignIn": 'https://localhost:8000/',
        "redirectSignOut": 'https://localhost:8000/',
        "responseType": 'code'
    },
    "aws_appsync_graphqlEndpoint": "https://22boctowkfbuzaidvbvwjxfnai.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "dvcapi",
            "endpoint": "https://uu5noh0v1i.execute-api.us-west-2.amazonaws.com/prd",
            "region": "us-west-2"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://2yi247yljl.execute-api.us-west-2.amazonaws.com/prd",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
